import { useCallback, useState } from 'react'

import { Flex } from 'components/common/flex/Flex'
import { ReactComponent as Title } from 'components/stepSection/assets/title.svg'
import { Scheme } from 'components/stepSection/scheme/Scheme'
import styles from 'components/stepSection/StepSection.module.scss'

export enum Steps {
  Step1 = 'Step1',
  Step2 = 'Step2',
  Step3 = 'Step3',
  Step4 = 'Step4',
}

export const StepSection = () => {
  const [activeStep, setActiveStep] = useState<Steps | null>(null)

  const handleStepEnter = useCallback(
    (step: Steps) => () => {
      setActiveStep(step)
    },
    [],
  )

  const handleStepLeave = useCallback(() => {
    setActiveStep(null)
  }, [])

  return (
    <Flex direction="column" align="center" gap={54} className={styles.container}>
      <Title className='lg:w-auto w-full'/>
      <Scheme activeStep={activeStep} onStepEnter={handleStepEnter} onStepLeave={handleStepLeave} />
    </Flex>
  )
}
